import { LocationItem } from './SearchJobRedirectProps'

export const buildLocationHierarchy = (locations: LocationItem[]) => {
  const hierarchy = new Map<string, string>()
  const parentToChildren = new Map<string, string[]>()
  
  locations.forEach(parent => {
    const childValues: string[] = []
    if (parent.children) {
      parent.children.forEach(child => {
        hierarchy.set(child.value, parent.value)
        childValues.push(child.value)
      })
    }
    parentToChildren.set(parent.value, childValues)
  })
  
  return { hierarchy, parentToChildren }
}

export const formatLocationsForURL = (selectedLocations: string[], locations: LocationItem[]): string[] => {
  const { hierarchy, parentToChildren } = buildLocationHierarchy(locations)
  const formattedLocations: string[] = []
  
  const parentGroups = new Map<string, string[]>()
  
  selectedLocations.forEach(location => {
    const parentCountry = hierarchy.get(location)
    if (parentCountry) {
      if (!parentGroups.has(parentCountry)) {
        parentGroups.set(parentCountry, [])
      }
      parentGroups.get(parentCountry)?.push(location)
    }
  })

  parentGroups.forEach((selectedChildren, parentCountry) => {
    const allChildren = parentToChildren.get(parentCountry) || []

    const allChildrenSelected = allChildren.length > 0 && 
                                allChildren.every(child => selectedChildren.includes(child))
    
    if (allChildrenSelected) {
      formattedLocations.push(parentCountry)
    } else {
      selectedChildren.forEach(child => {
        const cityFormatted = child.replace(/,/g, '  ')
        formattedLocations.push(`${parentCountry}/${cityFormatted}`)
      })
    }
  })
  
  return formattedLocations
}

export interface BuildSearchURLOptions {
  searchText: string
  selectedLocations: string[]
  locations: LocationItem[]
  redirectPath: string
  hashCode?: string
}

export const buildSearchURL = (options: BuildSearchURLOptions): string => {
  const { searchText, selectedLocations, locations, redirectPath, hashCode } = options
  const params = new URLSearchParams()
  const filterPrefix = hashCode && hashCode !== '0' ? `filterable${hashCode}` : 'filterable1573558966'
  
  if (selectedLocations.length > 0) {
    const formattedLocations = formatLocationsForURL(selectedLocations, locations)
    
    if (formattedLocations.length > 0) {
      const locationString = formattedLocations.join(',')
      params.append(`${filterPrefix}-location`, locationString)
    }
  }
  
  if (searchText && searchText.trim() !== '') {
    params.append(`${filterPrefix}-searchJobs`, searchText.trim())
  }
  
  const queryString = params.toString()
  return queryString ? `${redirectPath}?${queryString}` : redirectPath
}

export const getAllChildValues = (item: LocationItem): string[] => {
  const values: string[] = []
  if (item.children) {
    item.children.forEach(child => {
      values.push(child.value)
      if (child.children) {
        values.push(...getAllChildValues(child))
      }
    })
  }
  return values
}
